// Shared entry resolver for the WhatsApp entry routes (/factory/inbox/:slug and
// /f/:slug).
//
// Deliberately a PURE function: it fetches nothing and navigates nothing. Each
// entry route resolves its own facts — they are keyed on different slugs and
// different RPCs — and feeds them in, so both share ONE definition of the states
// and it stays trivially testable.
//
// ⚠️ THE TWO CALLERS NOW ACT ON THE RESULT AT DIFFERENT MOMENTS, and this file
// deliberately does not know which:
//   · /factory/inbox/:slug redirects on load, as before — it IS the inbox, and
//     there is nothing to show someone who cannot open it.
//   · /f/:slug shows the request FIRST and applies claim/login only when the
//     factory presses "respond" (Majeed, 2026-09-16, reversing 1fcc4a7:
//     registration is the price of replying, not of reading).
// The states and destinations below are identical for both. If a future change
// makes them differ, it belongs in the caller, not here.
//
// The four states, plus the one the brief did not name:
//   signed in + owner                  → 'owner'          (caller resolves the thread)
//   signed in + claimed by another     → 'other_account'  (neutral panel, no leak)
//   signed out + claimed               → 'login'          (never "owned by another":
//                                                          this is the owner arriving
//                                                          from WhatsApp)
//   signed out + unclaimed             → 'claim'
//   signed IN + unclaimed, not owner   → 'claim'          (they can legitimately claim
//                                                          it; a wall would be a dead
//                                                          end for the first claimant)

export const ENTRY = {
  OWNER: 'owner',
  OTHER_ACCOUNT: 'other_account',
  LOGIN: 'login',
  CLAIM: 'claim',
};

export function resolveFactoryEntry({ signedIn, alreadyClaimed, isOwner, claimSlug, nextPath }) {
  if (signedIn && isOwner) return { action: ENTRY.OWNER };

  if (alreadyClaimed) {
    if (signedIn) return { action: ENTRY.OTHER_ACCOUNT };
    // /login/supplier, not /login?mode=supplier: the supplier variant is a ROUTE
    // param (Login.jsx:271 reads useParams().role), not a query param. `mode` is
    // signin/signup only, so ?mode=supplier would be inert AND render the buyer
    // login. lang=zh because this audience is Chinese factories (Login.jsx:269
    // accepts en|zh and ignores anything else).
    return { action: ENTRY.LOGIN, to: `/login/supplier?lang=zh&next=${encodeURIComponent(nextPath)}` };
  }

  return { action: ENTRY.CLAIM, to: `/claim/${claimSlug}?next=${encodeURIComponent(nextPath)}` };
}
